import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import "./i18n";
import { Provider, useSelector } from "react-redux";
import MainRoutes from "./routes";
import { unstable_batchedUpdates } from "react-dom";
import store from "./redux/store";
import { useFormValidation } from "./utils/formValidations";
import { syncFCMTokenIfLoggedIn } from "./utils/fcmSync";

// Silenciar los errores de consola solo en desarrollo; en producción deben quedar visibles
// para poder diagnosticar fallos (incluidos los capturados por el ErrorBoundary)
if (process.env.NODE_ENV === "development") {
  unstable_batchedUpdates(() => {
    console.error = () => {};
  });
}

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-page">
          <h1>Algo salió mal. Por favor, recarga la página.</h1>
        </div>
      );
    }
    return this.props.children;
  }
}

// Componente de sincronización que se monta dentro del Provider
const FcmSync = () => {
  // Extraer el usuario del store
  const user = useSelector((state) => state.auth.user);
  React.useEffect(() => {
    if (user) {
      syncFCMTokenIfLoggedIn(user);
    }
  }, [user]);
  return null; // No renderizar nada
};

const Root = () => {
  useFormValidation();

  return (
    <div className="App">
      <Provider store={store}>
        {/* Montar el sincronizador justo al cargar */}
        <FcmSync />
        <MainRoutes />
      </Provider>
    </div>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary>
    <Root />
  </ErrorBoundary>
);

// Limpiar service worker antiguo de CRA (causaba error MIME type text/html)
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => {
      const scriptUrl = registration.active?.scriptURL || "";
      if (scriptUrl.includes("/service-worker.js")) {
        registration.unregister();
      }
    });
  });
}

// Registrar el Service Worker para notificaciones en segundo plano
if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/firebase-messaging-sw.js")
    .then((registration) => {
      console.info("Service Worker registrado con éxito:", registration);
    })
    .catch((error) => {
      console.error("Error al registrar el Service Worker:", error);
    });
}

